import { render, staticRenderFns } from "./ListarSalarioMinimo.vue?vue&type=template&id=8d97d1c8&"
import script from "./ListarSalarioMinimo.vue?vue&type=script&lang=js&"
export * from "./ListarSalarioMinimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports